<!-- #region "location-amount" -->
<ng-container *ngIf="reportService.showLocationAmountPage()">
    <div class="row my-2 location__amount__page" *ngIf="currentReport && currentReport.LATEST">
        <div class="col-md-11">
            <div class="color-secondary-gray font-size-14 font-weight-normal mb-3">
                Please provide information regarding the real estate from which the Company operates.
            </div>

            <div class="row mt-5">
                <div class="col-md-12">
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="label">How many locations does the Company operate from?</div>
                        <div class="font-size-14 font-weight-bold color--blue">REQUIRED</div>
                    </div>

                    <div class="d-flex">
                        <radio-group-button [selectedOption]="selectedLocationLength" [btnList]="amountList"
                            [disabled]="currentReport?.isLocked"
                            [isButton]="false" radioGroupButtonId="location-length-type-radio-group" (optionChange)="selectedLocationLength = $event; isEnterMore = false">
                        </radio-group-button>

                        <label class="btn btn-white bg-white rounded-0 more" role="button"
                            [class.selected]="isEnterMore"
                            (click)="isEnterMore = !isEnterMore; selectedLocationLength = null;">
                            <small class="font-weight-bold">Enter more</small>
                        </label>
                    </div>

                </div>
            </div>

            <ng-container *ngIf="isEnterMore">
                <div class="row mt-3">
                    <div class="col-md-12">
                        <div class="label">Location Amount</div>
                        <input type="text" id="selected-location-amount-length" numbersOnly
                            class="input input__large input__blue" [(ngModel)]="selectedLocationLength" required
                            #locationCountInput="ngModel" name="locationCountInput" [range]="[1, 20]"
                            placeholder="Please enter the amount of locations" maxlength="2" [disabled]="currentReport?.isLocked">
                            <small *ngIf="locationCountInput.errors?.range && (locationCountInput.dirty || locationCountInput.touched)" class="text-danger">
                                Please enter value between 1 to 20
                            </small>
                    </div>
                </div>
            </ng-container>

        </div>
    </div>
</ng-container>
<!-- #endregion -->

<!-- #region "location-details" -->
<ng-container *ngIf="!reportService.showLocationAmountPage()">
    <div class="location__details__page report__page__with__extra__scroll">
        <div class="row my-2" *ngIf="currentReport && currentReport.LATEST">
            <div class="col-md-12 d-flex align-items-center">

                <div role="group" class="group__buttons custom__scroll">
                    <button class="button small__button half-rounded__button mr-2 mb-2 ellipsis"
                        *ngFor="let location of currentReport.LATEST.LOCATION_LIST; let i = index"
                        [ngClass]="{'primary__button parent-button': selectedLocation && location.ID == selectedLocation.ID}"
                        id="{{'latest-location-list-report-'+i}}"
                        [class.secondary__button]="!selectedLocation || location.ID != selectedLocation.ID"
                        (click)="selectLocation(location)">
                        {{reportService.checkStringWithTrim(location.DISPLAY_NAME) ? location.DISPLAY_NAME :
                            location.NAME ? location.NAME : i ? 'Location ' + (i + 1) : 'Primary Location'}}

                        <button id="{{'selected-location-list-remove'+i}}" class="child-button button ghost__button small__button rounded__button"
                            *ngIf="selectedLocation && location.ID == selectedLocation.ID && i"
                            [disabled]="currentReport?.isLocked"
                            (click)="deleteLocation(location.ID, i)">
                            <img src="../../../../../../assets/images/trash.svg" alt="...">
                        </button>
                    </button>

                    <button *ngIf="currentReport.LATEST.LOCATION_LIST.length < 20"
                        class="button small__button icon__right half-rounded__button blue__bordered__button mr-1 mb-1 add__hover"
                        id="add-blank-location" [disabled]="currentReport?.isLocked"
                        (click)="addBlankLocation()">
                        Add Location <em class="fa fa-plus"></em>
                    </button>

                </div>

            </div>
        </div>

        <div class="my-5" *ngIf="selectedLocation && selectedLocation.ID">
            <form #locationForm="ngForm" id="locationForm" novalidate="novalidate" autocomplete="off">

                <div class="row">
                    <div class="col-md-12">
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="label">Location Type</div>
                            <div class="font-size-14 font-weight-bold color--blue">REQUIRED</div>
                        </div>
                        <div class="color-secondary-gray font-size-14 font-weight-normal mb-3">
                            Please choose the best description for the type of facility the Company operates out of.
                        </div>

                        <div class="row m-0">
                            <div class="col-md-12 p-0">
                                <radio-group-button [selectedOption]="selectedLocation.LOCATION_TYPE"
                                    [btnList]="locTypeList" [isButton]="true" [disabled]="currentReport?.isLocked"
                                    [(ngModel)]="selectedLocation.LOCATION_TYPE" required id="LOCATION_TYPE"
                                    #LOCATION_TYPE="ngModel" name="LOCATION_TYPE" [boxClasses]="'single-option-per-row'"
                                    radioGroupButtonId="selected-location-type-radio-group"
                                    (optionChange)="selectedLocation.LOCATION_TYPE = $event; callUpdateAPI('LOCATION_TYPE')">
                                </radio-group-button>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="mt-5" *ngIf="selectedLocation.LOCATION_TYPE">

                    <ng-container *ngIf="selectedLocation.LOCATION_TYPE == locationType.OTHER">
                        <div class="row mt-3">
                            <div class="col-md-12">
                                <div class="d-flex align-items-center justify-content-between">
                                    <div class="label">Other Type</div>
                                    <div class="font-size-14 font-weight-bold color--blue">REQUIRED</div>
                                </div>
                                <input type="text" restrictFirstSpace class="input input__large input__blue" maxlength="150"
                                    [(ngModel)]="selectedLocation.OTHER_TYPE" placeholder="Please explain"
                                    [disabled]="currentReport?.isLocked" appAlphabetWithSpaceOnly
                                    (blur)="callUpdateAPI('OTHER_TYPE')" (keyup.enter)="callUpdateAPI('OTHER_TYPE')"
                                    required id="OTHER_TYPE" #OTHER_TYPE="ngModel" name="OTHER_TYPE">
                            </div>
                        </div>
                    </ng-container>

                    <!-- Name -->
                    <div class="row mt-3" *ngIf="false">
                        <div class="col-md-12">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="label">Name</div>
                                <div class="font-size-14 font-weight-bold color--blue">REQUIRED</div>
                            </div>

                            <input restrictFirstSpace type="text" class="input input__large input__blue" required
                                [ngModel]="selectedLocation.DISPLAY_NAME ? selectedLocation.DISPLAY_NAME : selectedLocation.NAME"
                                (ngModelChange)="selectedLocation.DISPLAY_NAME = $event" maxlength="50"
                                [disabled]="currentReport?.isLocked"  (focus)="focusLocationName()"
                                placeholder="e.g.: Head office, warehouse, shop 1, etc.."
                                (blur)="makeDefaultName()"
                                id="NAME" #NAME="ngModel" name="NAME">
                        </div>
                    </div>

                    <!-- Address -->
                    <div class="row mt-3">
                        <div class="col-md-12">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="label">Address</div>
                                <div class="color--light--gray font-size-14 font-weight-bold">Optional</div>
                            </div>

                            <input restrictFirstSpace type="text" class="input input__large input__blue"
                                   [disabled]="currentReport?.isLocked"
                                [(ngModel)]="selectedLocation.ADDRESS" placeholder="e.g.: 28 Abbey Road" maxlength="150"
                                (blur)="callUpdateAPI('ADDRESS')" (keyup.enter)="callUpdateAPI('ADDRESS')" id="ADDRESS"
                                #ADDRESS="ngModel" name="ADDRESS">
                        </div>
                    </div>

                    <!-- ZIP -->
                    <div class="row mt-3">
                        <div class="col-md-12">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="label">Zip Code</div>
                                <div class="font-size-14 font-weight-bold color--blue">REQUIRED</div>
                            </div>
                            <input numbersOnly type="text" maxlength="5" class="input input__blue input__large"
                                (keypress)="_keyPress($event)"
                                (ngModelChange)='zipModelchangedFun($event)'
                                [(ngModel)]="selectedLocation.ZIP.ZIP" placeholder="e.g.: 42000"
                                (paste)="selectedLocation.ZIP.ZIP = $event.clipboardData.getData('text/plain'); zipEntered()"
                                (focusout)="focusOutZip()" [disabled]="currentReport?.isLocked"
                                required id="ZIP" #ZIP="ngModel" name="ZIP">
                        </div>
                    </div>

                    <!-- City State -->
                    <div class="row mt-3">
                        <div class="col-md-6">
                            <div class="label">City</div>
                            <input restrictFirstSpace type="text" class="input input__blue input__large" required
                                id="CITY" #CITY="ngModel" name="CITY" disabled [(ngModel)]="selectedLocation.CITY" placeholder="Autofilled based on Zip Code" >
                        </div>

                        <div class="col-md-6">
                            <div class="label">State</div>
                            <input restrictFirstSpace type="text" class="input input__blue input__large" required
                                id="STATE" #STATE="ngModel" name="STATE" disabled [(ngModel)]="selectedLocation.STATE" placeholder="Autofilled based on Zip Code">
                        </div>
                    </div>

                    <div class="row mt-5">
                        <div class="col-md-12 font-weight-bold">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="label">Rent Adjustment</div>
                                <div class="font-size-14 font-weight-bold color--blue">REQUIRED</div>
                            </div>
                            <div class="color-secondary-gray font-size-14 font-weight-normal mb-1">
                              Does the business owner(s) or a related entity own any part of the real estate where the company operates?
                            </div>

                            <div class="row m-0">
                                <div class="col-md-12 p-0">
                                    <radio-group-button [selectedOption]="selectedLocation.IS_OWNED"
                                        [btnList]="booleanOptions" [isButton]="true"
                                        [disabled]="currentReport?.isLocked"
                                        radioGroupButtonId="location-is-owned-type-radio-group"
                                        (optionChange)="selectedLocation.IS_OWNED = $event; callUpdateAPI('IS_OWNED')"
                                        [(ngModel)]="selectedLocation.IS_OWNED" required id="IS_OWNED"
                                        #IS_OWNED="ngModel" name="IS_OWNED">
                                    </radio-group-button>
                                </div>
                            </div>

                            <div class="row m-0" *ngIf="selectedLocation.IS_OWNED && selectedLocation.IS_OWNED != null">
                                <div class="col-md-12 mt-4 p-0">
                                    <div class="d-flex align-items-center justify-content-between">
                                        <div class="label">Does the Company (business entity being valued) own the real estate where the business operates?</div>
                                        <div class="font-size-14 font-weight-bold color--blue">REQUIRED</div>
                                    </div>
                                    <div class="color-secondary-gray font-size-14 font-weight-normal mb-1">
                                        e.g.: business entity holds real estate on its own balance sheet
                                    </div>
                                    <radio-group-button [selectedOption]="selectedLocation.IS_OWNED_ON_BS"
                                        [btnList]="booleanOptions" [isButton]="true"
                                        [(ngModel)]="selectedLocation.IS_OWNED_ON_BS" required id="IS_OWNED_ON_BS"
                                        #IS_OWNED_ON_BS="ngModel" name="IS_OWNED_ON_BS"
                                                        [disabled]="currentReport?.isLocked"
                                        radioGroupButtonId="selected-location-owned-type-radio-group"
                                        (optionChange)="selectedLocation.IS_OWNED_ON_BS = $event; callUpdateAPI('IS_OWNED_ON_BS')">
                                    </radio-group-button>
                                </div>
                            </div>

                            <div class="row m-0"
                                *ngIf="!selectedLocation.IS_OWNED && selectedLocation.IS_OWNED != null">
                                <div class="col-md-12 mt-4 p-0">
                                    <div class="d-flex align-items-center justify-content-between">
                                        <div class="label">Will the current Rent expense change post-transaction (or after the date of this valuation)?</div>
                                        <div class="font-size-14 font-weight-bold color--blue">REQUIRED</div>
                                    </div>
                                    <radio-group-button [selectedOption]="selectedLocation.IS_RENT_INCREASE"
                                        [btnList]="booleanOptions" [isButton]="true"
                                        [(ngModel)]="selectedLocation.IS_RENT_INCREASE" required id="IS_RENT_INCREASE"
                                        #IS_RENT_INCREASE="ngModel" name="IS_RENT_INCREASE"
                                                        [disabled]="currentReport?.isLocked"
                                        radioGroupButtonId="selected-location-rent-increase-type-radio-group"
                                        (optionChange)="selectedLocation.IS_RENT_INCREASE = $event; callUpdateAPI('IS_RENT_INCREASE')">
                                    </radio-group-button>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

            </form>
        </div>
    </div>
</ng-container>
<!-- #endregion -->
<report-footer [nextBtnEnable]="(reportService.showLocationAmountPage() && selectedLocationLength && selectedLocationLength > 0 && selectedLocationLength <= 20) || (locationForm && !locationForm.invalid)"
    (buttonClicked)="footerButtonClick($event)" [pageId]="reportPageConst.LOCATION"></report-footer>
